import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { MergeSource } from '../../decorators/decorators/merge.source';
import { AccountContactMergeData } from '../data/account.contact.merge.data';
import { AccountMergeData } from '../data/account.merge.data';
import { AttachmentsMergeData, AttachmentsMergeSchema } from '../data/activity.merge.data';
import { CompanyMergeData } from '../data/company.merge.data';
import { EmployeeMergeData, EmployeeMergeSchema } from '../data/employee.merge.data';
import { JobSiteMergeData } from '../data/job.site.merge.data';
import { OtherMergeData, OtherMergeDataSchema } from '../data/other.merge.data';
import { StageIncludeItemsMergeData, StageIncludeItemsMergeDataSchema } from '../data/stage.include.items.merge.data';
import { StageMergeData } from '../data/stage.merge.data';
import { TimesheetArrayMergeData, TimesheetArrayMergeDataSchema } from '../data/timesheet.merge.data';
import { AccountContactMergeSchema } from '../data/account.contact.merge.data';
import { AccountMergeSchema } from '../data/account.merge.data';
import { CompanyMergeSchema } from '../data/company.merge.data';
import { JobSiteMergeSchema } from '../data/job.site.merge.data';
import { StageMergeSchema } from '../data/stage.merge.data';
import { TaskArrayMergeData, TaskArrayMergeDataSchema } from '../data/task.merge.data';

@MergeDataset({
    entity: ActivityEntityName.WorkOrder,
    dependsOn: [ActivityEntityName.Job]
})
export class StageMergeDataset {

    @MergeSource({
        schema: StageMergeSchema,
        ignoreFields: ['items']
    })
    stage: StageMergeData;

    @MergeSource({
        schema: JobSiteMergeSchema
    })
    stageSite: JobSiteMergeData;

    @MergeSource({
        schema: AccountMergeSchema,
        ignoreFields: ['creditOutstandingInvoicesAmount', 'creditOverdueInvoicesAmount']
    })
    stageContractor: AccountMergeData;

    @MergeSource({
        schema: AccountContactMergeSchema
    })
    stageContractorContact: AccountContactMergeData;

    @MergeSource({
        schema: CompanyMergeSchema
    })
    stageBillingCompany: CompanyMergeData;

    @MergeSource({
        schema: EmployeeMergeSchema
    })
    stageOwner: EmployeeMergeData;

    @MergeSource({
        schema: StageIncludeItemsMergeDataSchema,
        includeFields: ['items', 'subTotalBuy', 'subTotalSell'],
        ignoreCustomFields: true,
    })
    stageItem: StageIncludeItemsMergeData;

    @MergeSource({
        schema: AttachmentsMergeSchema,
        ignoreCustomFields: true,
    })
    stageAttachment: AttachmentsMergeData;

    @MergeSource({
        schema: AttachmentsMergeSchema,
        ignoreCustomFields: true,
    })
    files: AttachmentsMergeData;

    @MergeSource({
        schema: OtherMergeDataSchema,
    })
    other: OtherMergeData;

    @MergeSource({
        schema: TaskArrayMergeDataSchema,
        ignoreCustomFields: true,
    })
    stageTasks: TaskArrayMergeData;

    @MergeSource({
        schema: TimesheetArrayMergeDataSchema,
        ignoreCustomFields: true,
    })
    stageTimesheets: TimesheetArrayMergeData;
}

